import { BaseAPI } from './BaseAPI.js'
import {
  CampaignList,
  FieldMapping,
  RecordSortOrder,
  RecordStatusData,
  UploadFileResponse,
} from '../types/index.js'

export default class CampaignListsAPI extends BaseAPI<CampaignList> {
  override get resource(): string {
    return '/campaignLists'
  }

  public async recordStatuses(id: number | string): Promise<RecordStatusData> {
    const result = await this._client.get(
      `${this.resource}/${id}/recordStatuses`,
    )
    return (
      result.data.meta ?? { available: { available_count: 0 }, statuses: [] }
    )
  }

  public async resetList(id: number | string): Promise<void> {
    await this._client.put(`${this.resource}/${id}/resetRecordStatuses`)
  }

  public async reorderList(
    id: number | string,
    sortOrder: Array<RecordSortOrder>,
  ): Promise<void> {
    await this._client.put(`${this.resource}/${id}/reorderList`, { sortOrder })
  }

  public async uploadFile(
    id: number,
    file: any,
    // eslint-disable-next-line @typescript-eslint/no-unsafe-function-type
    updateProgress: Function,
  ): Promise<UploadFileResponse> {
    const formData = new FormData()

    formData.append('import_file', file)
    const fileUploadResponse = await this._client.post(
      `${this.resource}/${id}/upload`,
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
        onUploadProgress(progressEvent) {
          if (progressEvent.lengthComputable) {
            updateProgress(progressEvent)
          }
        },
      },
    )
    return fileUploadResponse.data.data
  }

  public async confirmMapping(
    id: number,
    mapping: FieldMapping,
  ): Promise<void> {
    await this._client.post(`${this.resource}/${id}/confirm-upload`, {
      data: {
        type: 'importMap',
        attributes: mapping,
      },
    })
  }
}
